import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pagination-container flex-centered col-12" }

import type { PropType } from 'vue';
import { scrollTop } from "@/utilities";

export type PaginationData = {
  totalCount: number;
  pageCount: number;
  pageSize: number;
  pageNumber: number;
  data: any[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: {
  data: { 
    type: Object as PropType<PaginationData>,
    default: {
      totalCount: 0,
      pageCount: 0,
      pageSize: 0,
      pageNumber: 0,
      data: []
    }
  },
  large: { default: false },
},
  emits: ["change"],
  setup(__props, { emit: emits }) {

const props = __props;




function pageChange(page: number) {
  if (page != props.data.pageNumber) {
    emits("change", page);
    scrollTop();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass({'large-buttons': __props.large})
    }, [
      _createVNode(_component_el_pagination, {
        background: "",
        "hide-on-single-page": "",
        "current-page": Number(__props.data.pageNumber),
        layout: "prev, pager, next",
        "page-count": __props.data.pageCount,
        total: __props.data.totalCount,
        "page-size": __props.data.pageSize,
        "pager-count": 7,
        onCurrentChange: pageChange
      }, null, 8, ["current-page", "page-count", "total", "page-size"])
    ], 2)
  ]))
}
}

})